const styles = theme => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: 300,
    backgroundColor: "white",
    "& img": {
      flex: 8,
      padding: "2px 2px 0",
      objectFit: "contain",
    },
    cursor: "pointer",
  },
  sponsored: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: theme.palette.primary.main,
    "& p": {
      fontFamily: "Open Sans,sans-serif",
      // color: "#545353",
      color: "white",
      fontSize: ".8rem",
      fontWeight: "normal",
      letterSpacing: ".5px",
    },
  },
})

export default styles
